import { CadastroBensModalComponent } from './_paginas/cadastro-bem/cadastro-bens-modal/cadastro-bens-modal.component';
import { ListagemDeInconsistenciaComponent } from './_paginas/listagem-de-inconsistencias/listagem-de-inconsistencia/listagem-de-inconsistencia.component';
import { ListaDeInconsistenciaComponent } from './_paginas/listagem-de-inconsistencias/lista-de-inconsistencia.component';
import { TelaDeInconsistenciasGestorComponent } from './_paginas/tela-de-inconsistencias-gestor/tela-de-inconsistencias-gestor/tela-de-inconsistencias-gestor.component';
import { InconsistenciaGestorComponent } from './_paginas/tela-de-inconsistencias-gestor/inconsistencia-gestor.component';
import { TelaDeInconsistenciasUsuarioComponent } from './_paginas/tela-de-inconsistencias-usuario/tela-de-inconsistencias-usuario/tela-de-inconsistencias-usuario.component';
import { RelatorioBensComponent } from './_paginas/relatorio-bens/relatorio-bens/relatorio-bens.component';
import { RelatorioComponent } from './_paginas/relatorio-bens/relatorio.component';
import { HistoricoBensComponent } from './_paginas/historico-bens/historico-bens/historico-bens.component';
import { HistoricoComponent } from './_paginas/historico-bens/historico.component';
import { TelaDeRecebimentoComponent } from './_paginas/tela-de-recebimento/tela-de-recebimento/tela-de-recebimento.component';
import { TelaDeReceberComponent } from './_paginas/tela-de-recebimento/tela-de-receber.component';
import { TelaDeAprovGestorComponent } from './_paginas/tela-de-aprov-gestor/tela-de-aprov-gestor/tela-de-aprov-gestor.component';
import { TelaAprovarGestorComponent } from './_paginas/tela-de-aprov-gestor/tela-aprovar-gestor.component';
import { LoginComponent } from './_paginas/login/login.component';
import { SolicitarBensComponent } from './_paginas/solicitar-bens/solicitar-bens.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule,PreloadAllModules } from '@angular/router';
import { HomeComponent } from './_paginas/home/home.component';

import {
  TipoDeBemComponent,
  TipoDeBensComponent
} from './_paginas/tipo-de-bem';
import {
  CadastrarBensComponent,
  CadastroBensComponent
} from './_paginas/cadastro-bem';
import { BemFuncionarioComponent } from './_paginas/bem-funcionario/bem-funcionario.component';
import { BensFuncionariosComponent } from './_paginas/bem-funcionario/bens-funcionarios/bens-funcionarios.component';
import { SolicitacaoBensComponent } from './_paginas/solicitar-bens/solicitacao-bens/solicitacao-bens.component';
import { AuthGuard } from './_core/helper/auth.guard';
import { LocalizarBensComponent } from './_paginas/localizacao-bens/localizar-bens.component';
import { LocalizacaoBensComponent } from './_paginas/localizacao-bens/localizacao-bens/localizacao-bens.component';
import { TelaDeLiberacaoComponent } from './_paginas/tela-de-liberacao/tela-de-liberacao/tela-de-liberacao.component';
import { MeuBemComponent, MeusBensComponent } from './_paginas/meus-bens';
import { InconsistenciaUsuarioComponent } from './_paginas/tela-de-inconsistencias-usuario/inconsistencia-usuario.component';
import { GrupoCautelaComponent } from './_paginas/cautela-grupos/grupo-cautela.component';
import { CautelaGruposComponent } from './_paginas/cautela-grupos/cautela-grupos/cautela-grupos.component';
import { RecebimentoGrupoComponent } from './_paginas/grupo-recebimentos/recebimento-grupo.component';
import { GrupoRecebimentoComponent } from './_paginas/grupo-recebimentos/grupo-recebimento/grupo-recebimento.component';
import { AlterarCautelaGrupoComponent } from './_paginas/grupo-alterar-cautela/alterar-cautela-grupo.component';
import { GrupoAlterarCautelaComponent } from './_paginas/grupo-alterar-cautela/grupo-alterar-cautela/grupo-alterar-cautela.component';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: { title: 'Login' },
    children: [
      {
        path: 'login',
        component: LoginComponent,
      }
    ]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { title: 'Principal' }
  },
  {
    path: 'tipoDeBem',
    component: TipoDeBemComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: TipoDeBensComponent
      }
    ]
  },
  {
    path: 'cadastrarBem',
    component: CadastroBensComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastrarBem/:id',
    component: CadastrarBensComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastrar-localizacao',
    component: LocalizarBensComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: LocalizacaoBensComponent
      }
    ]
  },
  {
    path: 'bem-funcionario',
    component: BemFuncionarioComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: BensFuncionariosComponent
      }
    ]
  },
  {
    path: 'liberar-bens',
    component: TelaDeLiberacaoComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./_paginas/tela-de-liberacao/tela-de-liberacao.module').then(m => m.TelaDeLiberacaoModule)
    
  },
  {
    path: 'solicitar-bens',
    component: SolicitarBensComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: SolicitacaoBensComponent
      }
    ]
  },
  {
    path: 'tela-aprov-gestor',
    component: TelaAprovarGestorComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: TelaDeAprovGestorComponent
      }
    ]
  },
  {
    path: 'tela-de-receber',
    component: TelaDeReceberComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: TelaDeRecebimentoComponent
      }
    ]
  },
  {
    path: 'historico',
    component: HistoricoComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HistoricoBensComponent
      }
    ]
  },
  {
    path: 'relatorio',
    component: RelatorioComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: RelatorioBensComponent
      }
    ]
  },
  {
    path: 'meu-bem',
    component: MeuBemComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:MeusBensComponent
      }
    ]
  },
  {
    path: 'inconsistencia-user',
    component: InconsistenciaUsuarioComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:TelaDeInconsistenciasUsuarioComponent
      }
    ]
  },
  {
    path: 'inconsistencia-gestor',
    component: InconsistenciaGestorComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:TelaDeInconsistenciasGestorComponent
      }
    ]
  },
  {
    path: 'lista-inconsistencia',
    component: ListaDeInconsistenciaComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:ListagemDeInconsistenciaComponent
      }
    ]
  },
  {
    path: 'grupo-cautela',
    component: GrupoCautelaComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:CautelaGruposComponent
      }
    ]
  },
  {
    path: 'grupo-recebimento',
    component: RecebimentoGrupoComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:GrupoRecebimentoComponent
      }
    ]
  },
  {
    path: 'grupo-alterar-cautela',
    component: AlterarCautelaGrupoComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component:GrupoAlterarCautelaComponent
      }
    ]
  },





];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true,preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
